import { Download } from 'lucide-react';
import { useState } from 'react';
import { ApiError, downloadFile, type QueryParams } from '../api/client';
import { Button } from './ui/Button';
import { useToast } from './ui/Toast';

/**
 * Export a report or list with the same filters as the screen, as Excel
 * (XLSX, numbers kept as numbers) or CSV.
 */
export function ExportButton({ report, params }: { report: string; params: QueryParams }) {
  const toast = useToast();
  const [busy, setBusy] = useState<'csv' | 'xlsx' | null>(null);
  const run = async (format: 'csv' | 'xlsx') => {
    setBusy(format);
    try {
      await downloadFile(`/exports/${report}`, { ...params, format }, `${report}.${format}`);
    } catch (err) {
      toast.error(err instanceof ApiError ? err.message : 'Export failed');
    } finally {
      setBusy(null);
    }
  };
  return (
    <span className="inline-flex rounded-lg shadow-sm">
      <Button
        variant="secondary"
        size="sm"
        icon={<Download className="size-4" />}
        loading={busy === 'xlsx'}
        onClick={() => void run('xlsx')}
        className="rounded-r-none"
        title="Download as Excel"
      >
        Excel
      </Button>
      <Button
        variant="secondary"
        size="sm"
        loading={busy === 'csv'}
        onClick={() => void run('csv')}
        className="-ml-px rounded-l-none"
        title="Download as CSV"
      >
        CSV
      </Button>
    </span>
  );
}
